import type { AuditLog, Customer, FollowUp, Opportunity, Product, Quote, Reminder, Sample, UsageMetrics } from "../types/crm";

const now = new Date();
const inDays = (days: number) => new Date(now.getTime() + days * 86400000).toISOString();

export const demoProducts: Product[] = [
  { id: "demo-product-1", product_no: "YKY-HC-001", name: "氨基酸修护洗发水", english_name: "Amino Acid Repair Shampoo", category: "洗护", specification: "OEM/ODM", capacity: "300ml", unit: "瓶", default_moq: 1000, sample_cycle_days: 10, default_packaging: "PET 按压瓶 + 彩盒", efficacy: "温和清洁、受损修护", formula_type: "无硫酸盐", supplier_info: "核心洗护供应链", status: "active", formula_requirements: "氨基酸表活体系，可提供无硅版本", efficacy_requirements: "清洁后不干涩，提升梳理性", packaging_details: "支持瓶色、泵头和标签定制", pricing_details: "价格随配方、包材和数量核算", engineering_notes: "首样需同步粘度、香型和稳定性记录", image_urls: [], created_at: inDays(-120), updated_at: inDays(-3) },
  { id: "demo-product-2", product_no: "YKY-SC-008", name: "咖啡因头皮精华", english_name: "Caffeine Scalp Serum", category: "头皮护理", specification: "免洗精华", capacity: "50ml", unit: "瓶", default_moq: 1000, sample_cycle_days: 14, default_packaging: "滴管瓶 + 彩盒", efficacy: "强韧发根、改善头皮环境", formula_type: "水基精华", supplier_info: "精华工程组", status: "active", formula_requirements: "咖啡因复配烟酰胺，清爽不黏腻", efficacy_requirements: "适合日常头皮护理", packaging_details: "可选滴管或喷头", pricing_details: "活性物添加量影响阶梯价", engineering_notes: "关注低温析出及包装相容性", image_urls: [], created_at: inDays(-95), updated_at: inDays(-6) },
  { id: "demo-product-3", product_no: "YKY-ST-003", name: "卷发定型霜", english_name: "Curl Defining Cream", category: "造型", specification: "中等定型", capacity: "150ml", unit: "支", default_moq: 1500, sample_cycle_days: 12, default_packaging: "软管", efficacy: "卷度定型、抗毛躁", formula_type: "乳霜", supplier_info: "造型产品供应链", status: "inactive", formula_requirements: "适合卷发和粗硬发质", efficacy_requirements: "定型自然、无白屑", packaging_details: "哑光软管", pricing_details: "停用产品仅供历史单据查询", engineering_notes: "旧版配方，等待替代版本", image_urls: [], created_at: inDays(-210), updated_at: inDays(-30) },
];

export const demoCustomers: Customer[] = [
  {
    id: "demo-customer-1",
    customer_no: 10001,
    company_name: "Aurora Botanics",
    contact_name: "Emma Wilson",
    country: "加拿大",
    website: "https://example.com",
    email: "emma@example.com",
    phone: "+1 416 555 0123",
    other_contact: null,
    inquiry_content: "计划开发天然洗发水、护发素和头皮精华，关注小批量打样与加拿大合规资料。",
    lead_source: "form",
    status: "sampling",
    grade: "A",
    is_key_account: true,
    tags: ["OEM", "头皮护理"],
    assigned_to: "demo-user",
    team_id: "demo-team",
    last_follow_up_at: inDays(-2),
    next_follow_up_at: inDays(0),
    lifecycle_status: "customer",
    development_stage: "sampling",
    source_detail: "官网",
    product_interest: "天然洗发水、护发素、头皮精华",
    estimated_quantity: 3000,
    estimated_value: 18000,
    lead_score: 90,
    lead_score_override: false,
    converted_at: inDays(-14),
    converted_by: "demo-user",
    created_at: inDays(-28),
    updated_at: inDays(-1),
  },
  {
    id: "demo-customer-2",
    customer_no: 10002,
    company_name: "Nura Beauty Trading",
    contact_name: "Sara Ahmed",
    country: "阿联酋",
    website: null,
    email: "sara@example.com",
    phone: "+971 50 555 0188",
    other_contact: null,
    inquiry_content: "希望获取卷发护理系列目录、MOQ、包装选择和报价。",
    lead_source: "whatsapp",
    status: "quoted",
    grade: "B",
    is_key_account: true,
    tags: ["卷发", "中东"],
    assigned_to: "demo-user",
    team_id: "demo-team",
    last_follow_up_at: inDays(-5),
    next_follow_up_at: inDays(-1),
    lifecycle_status: "customer",
    development_stage: "quotation",
    source_detail: "WhatsApp",
    product_interest: "卷发护理系列",
    estimated_quantity: 2000,
    estimated_value: 12000,
    lead_score: 78,
    lead_score_override: false,
    converted_at: inDays(-8),
    converted_by: "demo-user",
    created_at: inDays(-17),
    updated_at: inDays(-3),
  },
  {
    id: "demo-customer-3",
    customer_no: 10003,
    company_name: null,
    contact_name: "Lucas Martin",
    country: "法国",
    website: null,
    email: "lucas@example.com",
    phone: null,
    other_contact: null,
    inquiry_content: "咨询无硫酸盐洗护系列与欧盟 PIF/CPSR 文件支持。",
    lead_source: "email",
    status: "qualified",
    grade: "B",
    is_key_account: false,
    tags: ["欧盟合规"],
    assigned_to: "demo-user",
    team_id: "demo-team",
    last_follow_up_at: inDays(-1),
    next_follow_up_at: inDays(2),
    lifecycle_status: "customer",
    development_stage: "needs_confirmed",
    source_detail: "Email",
    product_interest: "无硫酸盐洗护系列",
    estimated_quantity: null,
    estimated_value: null,
    lead_score: 45,
    lead_score_override: false,
    converted_at: inDays(-3),
    converted_by: "demo-user",
    created_at: inDays(-9),
    updated_at: inDays(-1),
  },
  {
    id: "demo-customer-4",
    customer_no: 10004,
    company_name: "Cape Roots",
    contact_name: "Naledi Mokoena",
    country: "南非",
    website: null,
    email: null,
    phone: "+27 82 555 0146",
    other_contact: null,
    inquiry_content: "需要适合非洲市场的保湿洗发水，正在确认首单数量。",
    lead_source: "whatsapp",
    status: "contacted",
    grade: "C",
    is_key_account: false,
    tags: ["非洲市场"],
    assigned_to: "demo-user",
    team_id: "demo-team",
    last_follow_up_at: inDays(-7),
    next_follow_up_at: inDays(5),
    lifecycle_status: "customer",
    development_stage: "contacted",
    source_detail: "WhatsApp",
    product_interest: "保湿洗发水",
    estimated_quantity: null,
    estimated_value: null,
    lead_score: 25,
    lead_score_override: false,
    converted_at: inDays(-2),
    converted_by: "demo-user",
    created_at: inDays(-7),
    updated_at: inDays(-4),
  },
  {
    id: "demo-lead-1",
    customer_no: 11001,
    company_name: "Verde Salon Group",
    contact_name: "Sofia Rossi",
    country: "意大利",
    website: "https://example.org",
    email: "sofia@example.org",
    phone: "+39 320 555 0148",
    other_contact: "+39 320 555 0148",
    inquiry_content: "通过 Google Ads 咨询专业沙龙修护系列，预计首批 1500 套。",
    lead_source: "form",
    status: "new",
    grade: "B",
    is_key_account: false,
    tags: ["Google Ads", "沙龙渠道"],
    assigned_to: "demo-user",
    team_id: "demo-team",
    last_follow_up_at: null,
    next_follow_up_at: inDays(1),
    lifecycle_status: "prospect",
    development_stage: "to_contact",
    source_detail: "Google Ads",
    product_interest: "沙龙修护系列",
    estimated_quantity: 1500,
    estimated_value: 8500,
    lead_score: 40,
    lead_score_override: false,
    converted_at: null,
    converted_by: null,
    created_at: inDays(-2),
    updated_at: inDays(-1),
  },
  {
    id: "demo-lead-2",
    customer_no: 11002,
    company_name: "Nordic Curl Lab",
    contact_name: "Maja Jensen",
    country: "丹麦",
    website: null,
    email: "maja@example.org",
    phone: "+45 31 55 01 26",
    other_contact: "+45 31 55 01 26",
    inquiry_content: "LinkedIn 联系后已回复，明确需要卷发护理样品和 MOQ 报价。",
    lead_source: "other",
    status: "qualified",
    grade: "A",
    is_key_account: true,
    tags: ["LinkedIn", "卷发"],
    assigned_to: "demo-user",
    team_id: "demo-team",
    last_follow_up_at: inDays(-1),
    next_follow_up_at: inDays(0),
    lifecycle_status: "prospect",
    development_stage: "high_intent",
    source_detail: "LinkedIn",
    product_interest: "卷发护理样品",
    estimated_quantity: 2500,
    estimated_value: 15000,
    lead_score: 85,
    lead_score_override: false,
    converted_at: null,
    converted_by: null,
    created_at: inDays(-11),
    updated_at: inDays(0),
  },
  {
    id: "demo-lead-3",
    customer_no: 11003,
    company_name: "Belleza Pro MX",
    contact_name: "Camila Torres",
    country: "墨西哥",
    website: null,
    email: "camila@example.org",
    phone: null,
    other_contact: null,
    inquiry_content: "Instagram 询问防脱洗发水目录，已回复产品方向，数量待确认。",
    lead_source: "other",
    status: "qualified",
    grade: "B",
    is_key_account: false,
    tags: ["Instagram", "防脱"],
    assigned_to: "demo-sales",
    team_id: "demo-team",
    last_follow_up_at: inDays(-4),
    next_follow_up_at: inDays(2),
    lifecycle_status: "prospect",
    development_stage: "replied",
    source_detail: "Instagram",
    product_interest: "防脱洗发水",
    estimated_quantity: null,
    estimated_value: null,
    lead_score: 35,
    lead_score_override: false,
    converted_at: null,
    converted_by: null,
    created_at: inDays(-6),
    updated_at: inDays(-3),
  },
];

export const demoFollowUps: FollowUp[] = [
  { id: "follow-1", customer_id: "demo-customer-1", author_id: "demo-user", channel: "email", subject: "样品配方确认", content: "已发送三款基础配方和包装选项，等待客户确认香型。", occurred_at: inDays(-2), next_follow_up_at: inDays(0) },
  { id: "follow-2", customer_id: "demo-customer-2", author_id: "demo-user", channel: "whatsapp", subject: null, content: "客户已收到报价，需补充运输时间和付款条款。", occurred_at: inDays(-5), next_follow_up_at: inDays(-1) },
];

export const demoReminders: Reminder[] = [
  { id: "reminder-1", customer_id: "demo-customer-2", owner_id: "demo-user", owner_name: "演示管理员", title: "补充运输周期与付款条款", due_at: inDays(-1), completed_at: null, due_status: "overdue", created_at: inDays(-5), updated_at: inDays(-5), customer: demoCustomers[1] },
  { id: "reminder-2", customer_id: "demo-customer-1", owner_id: "demo-user", owner_name: "演示管理员", title: "确认样品香型", due_at: inDays(0), completed_at: null, due_status: "due_soon", created_at: inDays(-2), updated_at: inDays(-2), customer: demoCustomers[0] },
  { id: "reminder-3", customer_id: "demo-customer-3", owner_id: "demo-user", owner_name: "演示管理员", title: "发送欧盟合规文件清单", due_at: inDays(2), completed_at: null, due_status: "due_soon", created_at: inDays(-1), updated_at: inDays(-1), customer: demoCustomers[2] },
];

export const demoSamples: Sample[] = [
  { id: "sample-1", sample_no: "YKY-S-202608-001", customer_id: "demo-customer-1", product_id: "demo-product-1", product_name: "洗发水 + 护发素 + 头皮精华", version_no: 1, parent_sample_id: null, status: "engineering_review", priority: "high", current_department: "engineering", current_assignee: "demo-user", target_market: "加拿大", expected_ship_date: inDays(8).slice(0, 10), target_order_quantity: 3000, target_unit_price: 6, submitted_at: inDays(-5), accepted_at: inDays(-4), started_at: null, completed_at: null, due_at: inDays(-3), shipping_fee: 95.3, sample_fee: 120, currency: "USD", payment_method: "PayPal", is_paid: true, is_shipped: false, logistics_company: null, tracking_no: null, shipped_at: null, delivered_at: null, customer_feedback: null, test_result: "工程评估稳定性与香型方案", next_step: "完成工程方案后提交工厂", next_follow_up_at: inDays(3), notes: "客户要求天然配方与加拿大合规资料", owner_id: "demo-user", owner_name: "演示管理员", created_at: inDays(-6), updated_at: inDays(-1), customer: demoCustomers[0] },
  { id: "sample-2", sample_no: "YKY-S-202608-002", customer_id: "demo-customer-2", product_id: null, product_name: "卷发霜", version_no: 1, parent_sample_id: null, status: "in_transit", priority: "normal", current_department: "logistics", current_assignee: "demo-user", target_market: "阿联酋", expected_ship_date: inDays(-2).slice(0, 10), target_order_quantity: 2000, target_unit_price: 5.5, submitted_at: inDays(-7), accepted_at: inDays(-6), started_at: inDays(-5), completed_at: inDays(-3), due_at: inDays(1), shipping_fee: 76.18, sample_fee: 85, currency: "USD", payment_method: "PayPal", is_paid: true, is_shipped: true, logistics_company: "DHL", tracking_no: "DEMO-TRACK-001", shipped_at: inDays(-2), delivered_at: null, customer_feedback: null, test_result: "QC PASS", next_step: "签收后 3 天询问测试结果", next_follow_up_at: inDays(4), notes: "等待客户签收", owner_id: "demo-user", owner_name: "演示管理员", created_at: inDays(-7), updated_at: inDays(-2), customer: demoCustomers[1] },
];

export const demoOpportunities: Opportunity[] = [
  { id: "opp-1", customer_id: "demo-customer-1", title: "天然头皮护理系列首单", stage: "sampling", amount: 18000, currency: "USD", probability: 45, expected_close_date: inDays(40).slice(0, 10), product: "天然头皮护理系列", moq: 3000, next_follow_up_at: inDays(3), owner_id: "demo-user", owner_name: "演示管理员", notes: "样品确认后推进首单", created_at: inDays(-10), updated_at: inDays(-1), customer: demoCustomers[0] },
  { id: "opp-2", customer_id: "demo-customer-2", title: "卷发护理系列", stage: "quotation", amount: 12000, currency: "USD", probability: 60, expected_close_date: inDays(25).slice(0, 10), product: "卷发护理系列", moq: 2000, next_follow_up_at: inDays(2), owner_id: "demo-user", owner_name: "演示管理员", notes: "待确认运输周期", created_at: inDays(-12), updated_at: inDays(-3), customer: demoCustomers[1] },
];

export const demoQuotes: Quote[] = [
  { id: "quote-1", opportunity_id: "opp-2", customer_id: "demo-customer-2", quote_no: "YKY-Q-202608-001", status: "sent", total_amount: 12000, currency: "USD", product: "卷发护理系列", moq: 2000, valid_until: inDays(20).slice(0, 10), next_follow_up_at: inDays(2), owner_id: "demo-user", notes: "含标准包装，不含国际运费", created_by: "demo-user", creator_name: "演示管理员", created_at: inDays(-4), updated_at: inDays(-4) },
];

export const demoAuditLogs: AuditLog[] = [
  { id: "audit-stage-1", actor_id: "demo-user", actor_name: "演示管理员", action: "customer.stage_change", entity_type: "customer", entity_id: "demo-customer-1", customer_id: "demo-customer-1", details: { from: "qualified", to: "sampling", summary: "销售阶段从已确认调整为打样中" }, created_at: inDays(-6) },
  { id: "audit-owner-1", actor_id: "demo-user", actor_name: "演示管理员", action: "customer.owner_change", entity_type: "customer", entity_id: "demo-customer-1", customer_id: "demo-customer-1", details: { from: null, to: "demo-user", summary: "负责人调整为演示管理员" }, created_at: inDays(-14) },
];

export const demoUsage: UsageMetrics = {
  customer_count: demoCustomers.length,
  follow_up_count: demoFollowUps.length,
  attachment_count: 0,
  attachment_bytes: 0,
  import_count: 0,
  ai_call_count: 0,
};
